import React from 'react'
import {
  Card,
  CardBody,
  Stat,
  StatArrow,
  StatHelpText,
  StatLabel,
  Text
} from '@chakra-ui/react'
import { StatCardProps } from '../types'

const StatCard = ({ arrowType, bg, helpText, label, value }: StatCardProps) => (
  <Card bg={bg}>
    <CardBody>
      <Stat>
        <StatLabel>{label}</StatLabel>
        <Text fontWeight="bold" fontSize="xl">{value}</Text>
        {helpText && (
          <StatHelpText>
            {arrowType && <StatArrow type={arrowType} />}
            {helpText}
          </StatHelpText>
        )}
      </Stat>
    </CardBody>
  </Card>
)

export default StatCard
